module.exports = __webpack_public_path__ + "static/resources-img-1-3d061ee17523e38626543fda41fb972d.png";